import i18next from 'i18next';
import get from 'lodash/get';

import { createSegment } from 'common/api/v1/segmentsLayout';
import {
    //POLYGON_CIRCLE,
    POLYGON_MAP,
    POLYGON_OBSTACLE,
    POLYGON_SEGMENT,
} from 'common/components/segment/constants';
import { formatSegment } from 'common/components/segment/helpers';
import { movePoint } from 'common/components/segment/solarGeometryhelpers';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import {
    FETCH_OFFER_PANELS_SUCCESS,
    SAVE_SEGMENT,
    SAVE_SEGMENT_FAILURE,
    SAVE_SEGMENT_SUCCESS,
} from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';
import * as selectors from '../selectors';

import updateSegments from './updateSegments';

export default (item, commercialOfferId) => (dispatch, getState) => {
    const state = getState();
    const segments = selectors.getSegmentsData(state);

    let tmpSegments = [...segments];

    dispatch(panelLayoutV2Actions[SAVE_SEGMENT]());

    const data = item;
    const { name, polygon, parent_field_segment, type } = data;
    let newPanel = null;
    let solar_modules = [];

    const translatedPolygon = polygon.map((point) =>
        movePoint({ lnglat: [point[1], point[0]] }),
    );

    if (data.solar_modules) {
        solar_modules = data.solar_modules.map((module) => ({
            cell: module.cell,
            col: module.col,
            group: module.group,
            is_enable: module.enabled,
            row: module.row,
            solar_module_points: JSON.stringify(
                module.path.map((point) => {
                    const newPoint = movePoint({
                        lnglat: [point[1], point[0]],
                    });
                    return { x: newPoint[1], y: newPoint[0] };
                }),
            ),
        }));
    }

    const fieldSegments = [
        {
            name: `${i18next.t('Copy of')} ${name}`,
            polygon: translatedPolygon.map((point) => ({
                x_coordinate: point[1],
                y_coordinate: point[0],
            })),
            solar_modules,
        },
    ];

    const solarCharacterization = {
        azimuth: data.azimuth,
        col_spacing: data.col_spacing,
        frame_col_spacing: data.frame_col_spacing,
        frame_cols_number: data.frame_cols_number,
        frame_row_spacing: data.frame_row_spacing,
        frame_rows_number: data.frame_rows_number,
        orientation: data.orientation,
        polygon: JSON.stringify(translatedPolygon),
        row_spacing: data.row_spacing,
        safe_zone: data.safe_zone,
        tilt: data.tilt,
    };

    const solution_fields = {
        front_base_height: data?.front_base_height,
        lfoot_supports_width: data?.lfoot_supports_width || 1000,
        outer_rail_length: data?.outer_rail_length,
        rail_spacing: data?.rail_spacing || 0,
        rail_support_length: data?.rail_support_length || 1000,
        seam_distance: data.seam_distance,
        sheet_gauge: data.sheet_gauge,
        support_length: data?.support_length || 1500,
    };

    let newData = {
        commercial_offer: commercialOfferId,
        custom_inputs: {
            algorithm: data.algorithm,
            building_heading: data.building_heading,
            building_height: data.building_height,
            category: data.category,
            ceil_tilt: data.ceil_tilt,
            drawing_type: data.drawing_type,
            fill_algorithm: data.fill_algorithm,
            floor_height: data.floor_height,
            frontal_support: data.frontal_support,
            gclamp_type: data?.gclamp_type || 'GCLAMP_CONVENTIONAL',
            has_initial_height: data.has_initial_height,
            initial_height: data.initial_height,
            panel_orientation: data?.orientation || 'P',
            sloof_type: data.sloof_type,
            snow_load: data.snow_load,
            system_uid: data.system_uid,
            type_application: data.type_application,
            ...solution_fields,
        },
        field_segments: fieldSegments,
        groups: data.groups,
        parent_field_segment: data.parent_field_segment,
        segment_color: data.segment_color,
        segment_stroke_color: data.segment_stroke_color,
        solar_module: data.solar_module,
        solar_modules_number: solar_modules.length,
        system: data.system,
        total_area: data.total_area,
        type: data.type,
        zIndex: data.zIndex,
        ...solarCharacterization,
    };

    if (data.panel && data.panel.is_custom) {
        newPanel = {
            brand: data.panel.brandName,
            code: data.panel.code,
            depth: data.panel.depth,
            height: data.panel.height,
            is_custom: true,
            max_power: data.panel.max_power,
            name: data.panel.name,
            weight: data.panel.weight,
            width: data.panel.width,
        };

        newData.panel = newPanel;
    }

    if (type === POLYGON_MAP) {
        const { image, opacity, rotate } = data;
        newData.image = image;
        newData.opacity = opacity * 100;
        newData.rotate = rotate;
    }

    if (type === POLYGON_OBSTACLE || type === POLYGON_MAP) {
        newData.solar_module = null;
    }

    createSegment(newData)
        .then((response) => {
            const segmentData = get(response, 'data', {});
            const formatedSegment = formatSegment(
                segmentData,
                parent_field_segment,
            );
            const newSegment = { ...formatedSegment };

            if (data.type === POLYGON_MAP) {
                newSegment.image = data.image;
                newSegment.opacity = data.opacity;
                newSegment.rotate = data.rotate;
            }

            const newValuesSegments = [...tmpSegments, newSegment];

            dispatch(updateSegments(newValuesSegments));

            if (formatedSegment.type === POLYGON_SEGMENT) {
                const panels = newValuesSegments
                    .filter((segment) => segment.type === POLYGON_SEGMENT)
                    .map((segment) => segment.panel);

                dispatch(
                    panelLayoutV2Actions[FETCH_OFFER_PANELS_SUCCESS]({
                        panels,
                    }),
                );
            }

            dispatch(panelLayoutV2Actions[SAVE_SEGMENT_SUCCESS]());
        })
        .catch((error) => {
            dispatch(
                panelLayoutV2Actions[SAVE_SEGMENT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error.response);
        });
};
